import { useEffect, useState } from 'react';
import {
    ProgressCircle,
    ProgressCircleInner,
    RootDonut,
    Spinner,
} from './progress-indicator.styles';

export enum ProgressType {
    DONUT = 20,
    DONUT_LOADING = 21,
}
export interface ProgressIndicatorProps {
    progress: number;
    max?: number;
    type: ProgressType;
}

export function ProgressIndicator({ progress = 0, max = 100, type }: ProgressIndicatorProps) {
    const [opacity, setOpacity] = useState<number>(0);

    useEffect(() => {
        const timer = setTimeout(() => setOpacity(1), 500);
        return () => clearTimeout(timer);
    }, []);

    if (type === ProgressType.DONUT_LOADING) {
        return <Spinner opacity={opacity} />;
    }

    return (
        <RootDonut width="32px" height="32px" viewBox="0 0 32 32">
            <ProgressCircleInner r="14" cx="16" cy="16" />
            <ProgressCircle progress={progress} max={max} r="14" cx="16" cy="16" />
        </RootDonut>
    );
}
